<template>
    <UnauthenticatedLayout>
      <div class="login-page">        
        <img src="../assets/logo-login.png" alt="" class="logo">

        <div class="login-container">

          <h2 class="text-center text-white mb-6">Faça o login</h2>       
  
          <!-- Formulário de login -->
          <el-form label-position="top" :model="form" ref="formRef" @submit.prevent="handleLogin" label-width="100px" class="form-login">
            <el-form-item class="form-label" label="E-mail" :rules="emailRules">
              <el-input
                name="email"
                v-model="form.email"
                placeholder="Digite seu e-mail"
                class="w-full"
                type="email"
                size="large"
                :clearable="true"
              ></el-input>
            </el-form-item>
  
            <el-form-item class="form-label" label="Senha" :rules="passwordRules">
              <el-input
                v-model="form.password"
                placeholder="Digite sua senha"
                class="w-full"
                type="password"
                size="large"
                :clearable="true"
                show-password
              ></el-input>
            </el-form-item>

            <div class="btn-actions">              
                <!-- Links de ação -->
                <div class="account">
                  <el-link href="#" class="text-blue-500">Esqueceu a senha?</el-link>
                  <el-link href="/cadastro" class="text-blue-500">Criar uma conta</el-link>
                </div>
                
                <!-- Botão de login -->
                <el-button
                type="primary"
                size="large"
                class="w-full"
                @click="handleLogin"
                :loading="loading"
                >
                Entrar
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </UnauthenticatedLayout>
</template>
  
<script>
import { login } from '@/services/authService';

import { ElForm, ElFormItem, ElInput, ElButton, ElLink, ElNotification } from 'element-plus';
import UnauthenticatedLayout from '@/layouts/UnauthenticatedLayout.vue';
  
  export default {
    name: 'LoginView',
    components: {
      UnauthenticatedLayout,      
      ElForm,
      ElFormItem,
      ElInput,
      ElButton,
      ElLink      
    },
    data() {
      return {
        form: {
          email: '',
          password: '',
        },        
        loading: false,  // Controla o estado de loading
        emailRules: [
          { required: true, message: 'Por favor, insira seu e-mail', trigger: 'blur' },
          { type: 'email', message: 'O e-mail deve ser válido', trigger: ['blur', 'change'] },
        ],
        passwordRules: [
          { required: true, message: 'Por favor, insira sua senha', trigger: 'blur' },
        ],
      };
    },
    methods: {
      async handleLogin() {
        this.loading = true;
        try {
          await login(this.form.email, this.form.password);          

          ElNotification({
              title: 'Olá!',
              message: 'Seja bem-vindo(a)!',
              type: 'success'
          });

          this.$router.push('/');
          
        } catch (error) {
          ElNotification({
              title: 'Ops!',
              message: 'Login ou senha inválido! Por favor tente novamente!',
              type: 'error'
          });
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
  
<style scoped>
.form-login, .el-form-item__label {
  color: #fff !important;
}

  .login-page {    
    background: #171f3d;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .logo {
    width: 150px;
    margin: 20px 0;    
  }
  
  .login-container {
    background-color: rgba(0, 0, 0, 0.6); /* Fundo semi-transparente */
    padding: 40px;
    border-radius: 10px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }
  
  .text-center {
    text-align: center;
  }
  
  .text-white {
    color: white;
  }
  
  .text-blue-500 {
    color: #3b82f6;
  }
  
  .text-blue-500:hover {
    color: #2563eb;
  }
  .btn-actions {    
    display: flex;
    align-content: space-between;
    flex-direction: column;
    gap: 15px;
  }
  .account {    
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
  }
  .account a {
    text-decoration: none;
    color: #fff;
    font-weight: bold;
  }
  </style>
  